import {
	PLAN_STAGE_LABELS,
	planStageAllows,
	type PlanStage,
	type PlanStageFeature,
} from "@/shared/store";
import { Tool } from "@/widgets/editor";
import {
	MenuAreasButton,
	MenuSelectProjectButton,
	MenuDimensionsButton,
	MenuLayersButton,
	MenuObjectLayersButton,
	MenuOpeningsButton,
	MenuProjectButton,
	MenuSelectButton,
	MenuWallsButton,
	MenuWaterButton,
	MenuWiringButton,
} from "./MenuButtons";
import type { DrawerButtonContext, EditorToolRailItem } from "./types";

interface PlanButtonsContext extends DrawerButtonContext {
	tool: Tool;
	/** Этап чертежа: на нём часть разделов недоступна */
	planStage: PlanStage;
	showDimensions: boolean;
	showAreas: boolean;
	onSelect: () => void;
	onToggleDimensions: () => void;
	onToggleAreas: () => void;
	onSelectProject: () => void;
}

/** Раздел, которого на этом этапе нет: кнопка гаснет и подсказывает почему. */
const forStage = (
	context: PlanButtonsContext,
	feature: PlanStageFeature,
	item: EditorToolRailItem,
): EditorToolRailItem =>
	planStageAllows(context.planStage, feature)
		? item
		: {
				...item,
				disabled: true,
				tooltip: `${item.tooltip}: недоступно на этапе «${PLAN_STAGE_LABELS[context.planStage]}»`,
			};

/** Кнопки рейки редактора 2D-плана. */
export const planButtons = (context: PlanButtonsContext): EditorToolRailItem[] => {
	if (context.isReadOnly) {
		return [
			MenuLayersButton(context),
			MenuDimensionsButton({
				isEnabled: context.showDimensions,
				onClick: context.onToggleDimensions,
			}),
			MenuAreasButton({ isEnabled: context.showAreas, onClick: context.onToggleAreas }),
			MenuProjectButton(context),
			MenuSelectProjectButton({
				onClick: context.onSelectProject,
			}),
		];
	}
	return [
		MenuLayersButton(context),
		forStage(context, "catalog", MenuObjectLayersButton(context)),
		MenuSelectButton({
			isEnabled: context.tool === Tool.Select && context.drawer === null,
			onClick: context.onSelect,
		}),
		MenuDimensionsButton({
			isEnabled: context.showDimensions,
			onClick: context.onToggleDimensions,
		}),
		MenuAreasButton({ isEnabled: context.showAreas, onClick: context.onToggleAreas }),
		forStage(context, "walls", MenuWallsButton(context)),
		forStage(context, "openings", MenuOpeningsButton(context)),
		forStage(context, "wiring", MenuWiringButton(context)),
		forStage(context, "water", MenuWaterButton(context)),
		MenuProjectButton(context),
		MenuSelectProjectButton({
			onClick: context.onSelectProject,
		}),
	];
};
